import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, } from '@angular/router';
import { AuthService } from './api-endpoints.service';
import { Router } from '@angular/router';

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService)
  const router = inject(Router)

  console.log('crt route', state.url)
  console.log('crt route', authService)

  if (authService.authState()?.user == undefined) {
    authService.setRedirectUrl(state.url);
    console.log('state url', state.url)
    router.navigate([''])
    return false;
  } else {
    if (authService.hasRouteAccess(route.data['featureId'])) {
      // console.log('has featureID', route.data['featureId'])
      return true;
    } else {
      console.log('doesnt have featureID', route.data['featureId'])
      localStorage.removeItem('redirectUrl')
      router.navigateByUrl('/app')
      return true;
    }
  }
};